import React, { Fragment } from 'react';
import classNames from 'classnames';

import { getAuthHeaderText, getHeaderInfo } from 'home/view/check-feasibility/comp-generator/component.generator';
import { isLandingPage } from 'common/utils/app.utils';

import './subHeader.scss';

const headerSummary = ({
  userType,
  productName,
  handleClick,
  activeStepIndex,
  showTrackBtn = false,
  btnText = 'Track Open Purchase Request',
  onTrackBtnClick = () => {},
  hideBackBtn,
  isMultiSite = false,
  isUnAuthJourney = false,
  orderDetail
}) => {
  const isShiftingOrder = () => {
    return orderDetail?.orderType === 'CHANGE_ORDER' && orderDetail?.orderSubType === 'SHIFTING';
  };

  const subHeaderClassNames = classNames({
    sub_header: true,
    // bg_grey: isUnAuthJourney,
    bg_white: !isUnAuthJourney,
    container: isShiftingOrder()
  });

  const renderSubHeaderContent = () => {
    // if (isUnAuthJourney) {
    //   return <span className="title_text">{productName}</span>;
    // }

    if (isLandingPage()) {
      return getAuthHeaderText();
    }

    return getHeaderInfo(orderDetail);
  };

  // new ILL Redesign
  if (isUnAuthJourney) {
    return null;
  }

  return (
    <section className={subHeaderClassNames}>
      <div className={`header_content ${isMultiSite ? 'multi_site' : ''}`}>
        <div className={`header_title ${isMultiSite ? 'multi_site' : ''}`}>
          {!hideBackBtn && activeStepIndex < 3 && userType !== 'KAM' && (
            <span className="back" onClick={() => handleClick(activeStepIndex - 1)}>
              <i className="material-icons">chevron_left</i> <small>Go Back</small>
            </span>
          )}
          {renderSubHeaderContent()}
        </div>
      </div>
    </section>
  );
};

headerSummary.defaultProps = {
  hideBackBtn: false
};

export default headerSummary;
